import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Subject } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { TokenService } from '../token/token.service';
import { ProfileImg } from './profile-img';
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  businessId: any;
  profileInfoChange = new Subject();
  private businessInfo$: Promise<any> | undefined;

  constructor(
    private config: ConfigService,
    private http: HttpClient,
    private tokenServe: TokenService
  ) {
    this.businessId = this.tokenServe.getBusinessId();
  }

  // Step 1 & 2 & 3 starts

  async updateStep1(storeId: string, data: any): Promise<any> {
    const step1Data = await this.getStoreById(storeId);
    const nData = { ...step1Data, ...data, stepNo: 1 };
    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/${storeId}`, nData));
  }

  getStep1Data(): Promise<any> {
    const storeId: string = this.tokenServe.getStores()[0]?.id;
    if (!storeId) {
      console.warn('Store ID does not exist in login info');
      return Promise.resolve();
    }

    return this.getStoreById(storeId);
  }

  getStep2Data(): Promise<any> {
    return this.getStep1Data();
  }

  async updateStep2(storeId: string, data: any): Promise<any> {
    const step1Data = await this.getStoreById(storeId);
    const nData = { ...step1Data, ...data, stepNo: 2 };

    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/${storeId}`, nData));
  }

  async updateStep3(storeId: string, data: any): Promise<any> {
    const step1Data = await this.getStoreById(storeId);
    const nData = { ...step1Data, ...data, stepNo: 3 };
    let spaceData = await this.createStoreLocation(data, storeId);
    await lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/${storeId}`, nData));
    return spaceData;
  }

  // onboardng methods end


  // Add edit get store methods
  createStore(data: any): Promise<any> {
    const url = `${this.config.API_BASE}/api/v1/store/saveStore/${this.businessId}`;
    return lastValueFrom(this.http.post(url, data));
  }

  deleteStore(storeId: string): Promise<any> {
    const url = `${this.config.API_BASE}/api/v1/store/disable/${storeId}`;
    return lastValueFrom(this.http.get(url));
  }

  async updateStore(storeId: string, data: any): Promise<any> {
    const storeDetails = await this.getStoreById(storeId);
    const nData = { ...storeDetails, ...data };

    const url = `${this.config.API_BASE}/api/v1/store/${storeId}`;
    return lastValueFrom(this.http.put(url, nData));
  }

  getStoreById(storeId: string): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/${storeId}`));
  }

  getProfile(userId: string): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/userProfile/${userId}`));
  }

  /*  getBusinessDetails(): Promise<any> {
      return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/getBusiness/${this.businessId}`));
    }*/

  getBusinessDetails({ cache } = { cache: false }): Promise<any> {
    if (!this.businessInfo$ || !cache) {
      this.businessInfo$ = lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/getBusiness/${this.businessId}`));
    }

    return this.businessInfo$;
  }

  updateBussinessDetails(data: any): Promise<any> {
    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/updateBusiness/${this.businessId}`, data));
  }

  getBrandCategories(): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/brandbusiness/categories`));
  }

  getStoresByBusinessId(): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/getBusinessStores/${this.businessId}`));
  }

  updateProfileData(id: any, data: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/store/userProfile/${id}`, data))
  }

  createBrand(data: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/brandbusiness`, data))
  }

  updatePassword(data: any): Promise<any> {
    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/auth/updatePassword`, data))
  }

  newUploadMethod(data: FormData, { spaceId, storeId, brandId }: any) {
    if (storeId) {
      data.append('storeId', storeId);
    }

    if (spaceId) {
      data.append('spaceId', spaceId);
    }

    if (brandId) {
      data.append('brandId', storeId);
    }

    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/assets/upload/common/multipule2`, data));
  }

  newSpaceUploadMethod(data: FormData, { spaceId }: any) {
    if (spaceId) {
      data.append('spaceId', spaceId);
    }


    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/assets/upload/common/multipule2`, data));
  }

  // Profile Image
  getImageForProfileSection(urlPath: string): Promise<any> {
    // const url = `${this.config.API_BASE}${urlPath}`;
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/assets/upload${urlPath}`, { responseType: 'blob' }));
  }


  uploadBusinessImageFiles(file: File, key: ProfileImg, businessId?: string) {
    const data = new FormData();
    data.append('file', file);
    data.append('assetClassificationTypeEnum', key);
    if (businessId) {
      data.append('businessId', businessId);
    }

    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/assets/upload/common`, data));
  }


  async updateBusinessData(data: any): Promise<any> {
    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/updateBusiness/${this.businessId}`, data));
  }


  async checkIfMobileNumberAlreadyExists(mobile: any): Promise<any> {
    return this.http.get(`${this.config.API_BASE}/api/v1/customer/userProfile/validatemobile/${mobile}`);
  }

  async generateOTP(mobileObj: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/otp/generate`, mobileObj));
  }

  async validateOTP(mobileObj: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/otp/validate`, mobileObj));
  }

  async getStoreLocations(storeId: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/allStoreSpaces/${storeId}`));
  }

  async getStoreLocation(spaceId: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/getStoreSpace/${spaceId}`));
  }

  createStoreLocation(data: any, storeId: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.config.API_BASE}/api/v1/store/createStoreSpace/${storeId}`, data));
  }

  async updateStoreLocation(storeId: any, spaceId: any, data: any): Promise<any> {
    return lastValueFrom(this.http.put(`${this.config.API_BASE}/api/v1/store/updateStoreSpace/${storeId}/${spaceId}`, data));
  }

  async deleteStoreLocation(storeId: any): Promise<any> {
    return lastValueFrom(this.http.get(`${this.config.API_BASE}/api/v1/store/deleteStoreSpaces/${storeId}`));
  }
}
